<template>
  <main class="l-main p-register">
    <div class="l-block">
      <div class="mv-img mv-img_round">
        <img
          :src="require('@/assets/img/mv-register-register.png')"
          alt="本登録が完了しました！"
        />
      </div>
      <div class="l-block__content register">
        <div class="message">
          <h1 class="hTitle">
            <div class="thankYouTitle">
              <img src="@/assets/img/txt-thankyou.svg" alt="Thank you." />
            </div>
          </h1>
          <h2 class="h-minTitle">
            本登録が完了しました！
          </h2>
          <p class="c-text--center">
            ご登録有難うございます。SEARCH WRITEの会員登録が完了致しました。<br />
            下記のボタンからログインしてご利用ください。
          </p>
        </div>
        <div class="btnArea">
          <div class="form-auto">
            <Button
              :to="{ name: 'login' }"
              variant="main"
              size="w260"
              fsize="f16"
              icon="arrow_r"
            >
              ログインして利用する
            </Button>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Button from '@/components/Button';
export default {
  components: {
    Button
  }
};
</script>
